const STEPS = 3;
const TRUNCATION = "\u2026";
const generatePageRange = ({ totalPages, currentPage, }) => {
    const continuousNumbers = Array.from({ length: totalPages }, (_, i) => `${i + 1}`);
    // Early return for small page counts
    if (totalPages <= STEPS + 3) {
        return [...continuousNumbers];
    }
    const lastPage = continuousNumbers.at(-1);
    // Handle different pagination scenarios
    if (currentPage < STEPS + 1) {
        return [
            ...continuousNumbers.slice(0, STEPS + 1),
            TRUNCATION,
            lastPage,
        ];
    }
    if (currentPage > totalPages - STEPS) {
        return ["1", TRUNCATION, ...continuousNumbers.slice(-STEPS - 1)];
    }
    return [
        "1",
        TRUNCATION,
        ...continuousNumbers.slice(currentPage - STEPS / 2, currentPage + STEPS / 2),
        TRUNCATION,
        lastPage,
    ];
};

export { generatePageRange };
